const defaultQuota = 1;
/**
 * These should all be calculated with MaxDataAndIndexesSize, MaxEmulatorPayloadSize, etc. in mind, but there's probably
 * not an exact mapping, because of things like composite indexes in production.
 *
 * @see MaxDataAndIndexesSize
 * @see MaxEmulatorPayloadSize
 */
const perSubcollectionQuota = {
    /**
     *  Owner handle       Slug                                                  Median P90   P95   P99   Max
     *  ────────────────── ───────────────────────────────────────────────────── ────── ───── ───── ───── ─────
     *  jharwinbarrozo     led                                                   2706   2714  2714  2714  2714
     *  jharwinbarrozo     op-amp                                                2575   2577  2577  2577  2577
     *  ramprakashvishnoi8 arduino-blood-glucose-meter-shield                    2040   6363  6908  6927  7522
     *  jharwinbarrozo     nor-gate                                              2559   2560  2560  2560  2560
     *  lwcassid           polarized-capacitor                                   2580   2590  2590  2590  2590
     *  jharwinbarrozo     dc-supply                                             2758   6600  6600  6600  6600
     *  jharwinbarrozo     capacitive-fingerprint-sensor-with-arduino-or-esp8266 2746   8886  8886  8886  8886
     *  jharwinbarrozo     generic-resistor                                      2620   2621  2621  2621  2621
     *  usairemalamgeer    volumetric-wifi-led-strip-controller                  2076   7466  8438  8618  8652
     *  jharwinbarrozo     satnogs-rotator                                       2186   18019 18019 18019 18019
     *  jharwinbarrozo     waveform-generator                                    2501   2501  2501  2501  2501
     *  lwcassid           diy-quadruped-robot                                   4008   9246  9713  17055 17055
     *  jharwinbarrozo     generic-capacitor                                     2532   2533  2533  2533  2533
     *  jharwinbarrozo     breadboard-wrist-watch                                2996   6739  6741  7507  7507
     *  jharwinbarrozo     ground                                                2647   2647  2647  2647  2647
     *
     * These numbers are probably much higher on projects that use generic parts extensively. Generic Capacitor is
     * 46KiB, as is Generic Inductor, and Generic Resistor is 71KiB!
     */
    elements: 8,
    /**
     * Owner handle       Slug                                                  Median P90   P95   P99    Max
     * ────────────────── ───────────────────────────────────────────────────── ────── ───── ───── ────── ──────
     * jharwinbarrozo     op-amp                                                9555   12372 15535 18131  20207
     * ramprakashvishnoi8 arduino-blood-glucose-meter-shield                    3082   42938 55595 131988 188823
     * jharwinbarrozo     nor-gate                                              1168   5856  6332  10014  13606
     * jharwinbarrozo     capacitive-fingerprint-sensor-with-arduino-or-esp8266 1046   6349  11635 23075  100595
     * jharwinbarrozo     generic-resistor                                      2868   5728  12242 42594  44191
     * usairemalamgeer    volumetric-wifi-led-strip-controller                  2416   13890 19983 48151  210131
     * jharwinbarrozo     satnogs-rotator                                       1074   11670 14648 18111  101914
     * jharwinbarrozo     waveform-generator                                    11230  19313 19487 20705  21071
     * lwcassid           diy-quadruped-robot                                   2969   29680 37222 139995 350081
     * jharwinbarrozo     generic-capacitor                                     9876   10320 10324 10336  32375
     * jharwinbarrozo     breadboard-wrist-watch                                1076   5239  18750 54146  186640
     */
    actionRecords: 16,
    /**
     * These are known-small
     */
    configs: 1,
    active_users: 1,
    roles: 1,
};
export function quotaForOperationOnSubcollection(key) {
    return perSubcollectionQuota[key] ?? defaultQuota;
}
//# sourceMappingURL=quota.js.map